export default __webpack_public_path__ + "static/media/casa-pico-ruivo.e0995e8b.png";